import type { AreaCatalog } from '../area';
import type { views as en } from '../en/views';

export const views = {
  'views.page.title': 'Boards',
  'views.page.subEmpty': 'gemeinsame Orte für Aufgaben',
  'views.page.saved': '{count} gespeichert',
  'views.page.favorites': 'Favoriten',
  'views.page.all': 'Alle Boards',
  'views.page.archived': 'Archiviert',
  'views.page.empty':
    'Ein Board ist ein gemeinsamer Ort für Aufgaben. Alle darauf sehen dieselben Aufgaben.',
  'views.browse.title': 'Weitere Seiten',
  'views.browse.lenses': 'Ansichten',
  'views.browse.boards': 'Boards',
  'views.browse.groups': 'Gruppen',
  'views.browse.flowPhases': 'Ablaufphasen',
  'views.browse.flows': 'Abläufe',
  'views.browse.plans': 'Pläne',
  'views.browse.ceremonies': 'Besprechungen',
} as const satisfies AreaCatalog<typeof en>;
